<template>
  <div class="privacyAndAgreement">
    <iframe
      src="http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf"
      type="application/pdf"
      width="100%"
      height="100%"
    ></iframe>
  </div>
</template>

<script>
export default {
  setup() {},
  components: {},
}
</script>


<style lang="scss">
@import './utils.scss';
.privacyAndAgreement {
  padding: 55px 55px;
  font-size: 28px;
  font-family: PingFang SC;
  color: #333333;
  line-height: 46px;
  background-color: #fff;
  .title {
    font-size: 32px;
    font-weight: 400;
    color: #4c4c4c;
  }
}
</style>